
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"preserveAspectRatio":"none","viewBox":"0 0 1440 1024","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5557_8704)"}},[_c('path',{attrs:{"fill":"url(#paint0_linear_5557_8704)","d":"M0 0h1440v1024H0z"}}),_c('path',{attrs:{"d":"M-135.122 849.509c35.055 44.684 99.737 51.507 143.042 14.793C495.38 448.997 564.997 57.215 561.332-146.415c-1.317-65.67-65.303-112.329-128.417-93.883L73.239-134.485C36.678-124.078 9.918-93.034 2.847-55.507c-17.98 102.738-88.96 284.517-342.377 502.51-37.09 31.839-42.187 87.006-12.578 125.913l216.986 276.593z","fill":"#00AEEF"}}),_c('path',{attrs:{"opacity":".4","d":"M931.125 1560.27c-93.387.42-167.35-78.9-161.206-171.57C795.894 999.984 928.574 70.714 1581.54-296.824c63.42-36.073 144.9-7.657 172.84 59.979l139.65 338.18c27.94 67.637 4.4 145.788-56.49 187.563-345.83 238.922-429.23 868.472-449.41 1138.312-5.61 71.36-63.85 127.02-135.11 127.97-133.52 1.77-321.895 5.09-321.895 5.09z","fill":"#00AEEF"}})]),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_5557_8704","x1":"0","y1":"512","x2":"1440","y2":"512","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#00AEEF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#1471B9"}})]),_c('clipPath',{attrs:{"id":"clip0_5557_8704"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h1440v1024H0z"}})])])])
          )
        }
      }
    